export default "__VITE_ASSET__DXEGUaa6__"